import api from '../../store/config/api';
import { INTEGRATION as SCHEMA } from '../../schemas';

export const [
  GET_INTEGRATION,
  GET_INTEGRATION_REQUEST,
  GET_INTEGRATION_SUCCESS,
  GET_INTEGRATION_FAILURE
] = api.buildTypes('GET_INTEGRATION');

export function getIntegration({ teamName, intName }) {
  return {
    type: GET_INTEGRATION,
    payload: {
      url: `/teams/${teamName}/integrations/${intName}`,
      schema: SCHEMA
    }
  };
}

export const [
  ADD_INTEGRATION,
  ADD_INTEGRATION_REQUEST,
  ADD_INTEGRATION_SUCCESS,
  ADD_INTEGRATION_FAILURE
] = api.buildTypes('ADD_INTEGRATION');

export function addIntegration({
  teamName,
  appCredentials,
  nickname,
  appID,
  appName,
  appVersion,
  appState,
  isIntegration,
  isShared = true,
  username
}) {
  return {
    type: ADD_INTEGRATION,
    payload: {
      url: `/teams/${teamName}/integrations`,
      schema: SCHEMA,
      options: {
        method: 'POST',
        body: {
          appCredentials,
          nickname,
          appID,
          appName,
          appVersion,
          isIntegration,
          isShared,
          username,
          appState
        }
      }
    }
  };
}

export const [
  UPDATE_INTEGRATION,
  UPDATE_INTEGRATION_REQUEST,
  UPDATE_INTEGRATION_SUCCESS,
  UPDATE_INTEGRATION_FAILURE
] = api.buildTypes('UPDATE_INTEGRATION');

export function updateIntegration({ teamName, intName, ...other }) {
  return {
    type: UPDATE_INTEGRATION,
    payload: {
      url: `/teams/${teamName}/integrations/${intName}`,
      schema: SCHEMA,
      options: {
        method: 'PUT',
        body: other
      }
    }
  };
}

export const [
  DELETE_INTEGRATION,
  DELETE_INTEGRATION_REQUEST,
  DELETE_INTEGRATION_SUCCESS,
  DELETE_INTEGRATION_FAILURE
] = api.buildTypes('DELETE_INTEGRATION');

export function deleteIntegration({ teamName, intName }) {
  return {
    type: DELETE_INTEGRATION,
    payload: {
      url: `/teams/${teamName}/integrations/${intName}`,
      schema: SCHEMA,
      options: {
        method: 'DELETE'
      }
    }
  };
}



// WEBPACK FOOTER //
// ./js/actions/api/integration.js